module.exports = __webpack_public_path__ + "static/media/diamond-case.da077c20.png";